<template>
    <accordion-setting
        id="settingsGallery"
        title="Configurações Galeria"
        :visible="visible"
    >
        <!-- CONFIGURAÇÃO DE LARGURA -->
        <div class="py-2">
            <setting-frame-width
                :hasFullWidth="true"
                :item="item"
                @onChangeWidth="onChangeWidth"
            />
        </div>  

        <!-- CONFIGURAÇÃO DE TIPO DE GALERIA (ORGANISMO) -->
        <div class="py-2">
            <setting-frame-type-gallery
                :item="item"
                @onChangeTypeGallery="onChangeTypeGallery"
            />
        </div>

        <div 
            v-if="item.extra.maincontent_gallery_id"
            class="py-2"
        >
            <setting-frame-items-per-line
                :items="item.extra != null && item.extra.maincontent_gallery_items != null ? item.extra.maincontent_gallery_items : '3'"
                @onChangeItemsPerLine="onChangeItemsPerLine"
            />
        </div>

        <!-- CONFIGURAÇÃO DE MARGIN -->
        <div class="py-2">
            <setting-frame-margin
                :item="item"
                @onChangeMargin="onChangeMargin"
                @onChangeMarginMobile="onChangeMarginMobile"
                @onChangeLockMarginMobile="onChangeLockMarginMobile"
            />
        </div>
        
        <!-- CONFIGURAÇÃO DE PADDING -->
        <div class="py-2">
            <setting-frame-padding
                :item="item"
                @onChangePadding="onChangePadding"
                @onChangePaddingMobile="onChangePaddingMobile"
                @onChangeLockPaddingMobile="onChangeLockPaddingMobile"
            />
        </div>
    </accordion-setting>
</template>

<script>
import FlickerCarousel from "../atoms/FlickerCarousel.vue";
import SettingFrameTypeGallery from "../atoms/SettingFrameTypeGallery.vue";
import SettingFrameItemsPerLine from '../atoms/SettingFrameItemsPerLine.vue';
import SettingFrameWidth from "../atoms/SettingFrameWidth.vue";
import SettingFrameAdvanced from "../atoms/SettingFrameAdvanced.vue";
import SettingFrameMargin from '../atoms/SettingFrameMargin.vue';
import SettingFramePadding from '../atoms/SettingFramePadding.vue';
import AccordionSetting from '../atoms/AccordionSetting.vue';

export default {
    name: "SettingsFrameGallery",
    components: {
        SettingFrameWidth,
        SettingFrameTypeGallery,
        SettingFrameItemsPerLine,
        SettingFrameAdvanced,
        FlickerCarousel,
        SettingFrameMargin,
        SettingFramePadding,
        AccordionSetting
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        visible: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            defaultMargin: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            },
            defaultPadding: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            },
            defaultMarginMobile: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            },
            defaultPaddingMobile: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            },
        }
    },  
    methods: {
        handleSaveFrameConfig() {
            this.$emit("saveItemChanges", this.item);
        },
        onChangeTypeGallery(extra){
            this.item.extra.maincontent_gallery_items = extra.maincontent_gallery_items;
            this.item.extra.maincontent_gallery = extra.maincontent_gallery;
            this.item.extra.maincontent_gallery_items = extra.maincontent_gallery_items;
            this.item.extra.maincontent_gallery_items_mobile = extra.maincontent_gallery_items_mobile;
            this.item.extra.maincontent_gallery_items_crop = extra.maincontent_gallery_items_crop;
            this.item.extra.maincontent_gallery_padding = extra.maincontent_gallery_padding;

            this.handleSaveFrameConfig();
        },
        onChangePadding(value) {
            this.item.extra.padding = value;

            this.handleSaveFrameConfig();
        },
        onChangePaddingMobile(value) {
            this.item.extra.padding_mobile = value;
        },
        onChangeLockPaddingMobile(value) {
            this.item.extra.padding_mobile_lock = value;

            this.handleSaveFrameConfig();
        },
        onChangeMargin(value) {
            this.item.extra.margin = value;

            this.handleSaveFrameConfig();
        },
        onChangeMarginMobile(value) {
            this.item.extra.margin_mobile = value;

            this.handleSaveFrameConfig();
        },
        onChangeLockMarginMobile(value) {
            this.item.extra.margin_mobile_lock = value;

            this.handleSaveFrameConfig();
        },
        onChangeWidth(item) {
            this.item.grid = item.grid;
            this.item.gridMobile = item.gridMobile;

            this.handleSaveFrameConfig();
        },
        onChangeItemsPerLine(option) {
            this.item.extra.maincontent_gallery_items = option;

            this.handleSaveFrameConfig();
        },
    },
    created() {
        if (!this.item.extra) {
            this.item.extra = {};
        }

        if (!this.item.extra.padding) {
            this.item.extra.padding = this.defaultPadding;
        }

        if (!this.item.extra.padding_mobile) {
            this.item.extra.padding_mobile = this.defaultPaddingMobile;
        }

        if (!this.item.extra.margin) {
            this.item.extra.margin = this.defaultMargin;
        }

        if (!this.item.extra.margin_mobile) {
            this.item.extra.margin_mobile = this.defaultMarginMobile;
        }
    },
};
</script>



// WEBPACK FOOTER //
// src/components/molecules/SettingsFrameGallery.vue